import {FeatureSelector as FeatureSelectorShared} from '@dms/shared';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';

export function FeatureSelector() {
  const {formApi, vehicleType, baseTestId} = useVehicleFormContext();

  return (
    <FeatureSelectorShared
      formApi={formApi}
      name="features"
      vehicleType={vehicleType ?? undefined}
      columns={3}
      data-testid={`feature-selector-${baseTestId}`}
    />
  );
}
